import { Site } from 'graphql-common';
import SitePreview from 'components/SitePreview/SitePreview';
import Pagination from '@lib/components/Pagination/Pagination';
import styles from './SiteListGridView.module.scss';

type SiteListGridViewProps = {
  collection: Site[];
  isPaginationVisible: boolean;
  totalCount: number;
};

function SiteListGridView({
  collection,
  isPaginationVisible,
  totalCount,
}: SiteListGridViewProps) {
  return (
    <>
      <div className={styles.sitesGrid}>
        {collection.map((site) => (
          <div key={site.id}>
            <SitePreview {...site} />
          </div>
        ))}
      </div>
      {isPaginationVisible && (
        <div className={styles.pagination}>
          <Pagination totalEntries={totalCount} />
        </div>
      )}
    </>
  );
}

export default SiteListGridView;
